import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Paper, Typography } from "@mui/material";
import {
  Chart as ChartJS,
  Tooltip,
  Legend,
  ArcElement,
  registerables as registerablesJS,
} from "chart.js";
import { getEmployeeDiversity } from "../../../redux/actions";
import useStyles from "./styles";
import { getCookie } from "../../../services/cookie";

ChartJS.register(...registerablesJS);
ChartJS.register(ArcElement, Tooltip, Legend);

const DiversityGraph = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const role = getCookie("role");
  const companyId = getCookie("companyId");
  const diversityValues = useSelector(
    (state) => state.dashboard.getEmployeeDiversity.data
  );

  useEffect(() => {
    !props.refreshContent &&
      dispatch(getEmployeeDiversity(props.filter, role, companyId));
  }, [dispatch, props.filter]);

  return (
    <Paper className={classes.container}>
      <div className={classes.header}>
        <Typography className={classes.graphTitle}>Diversity</Typography>
        <Typography className={classes.subtitle}>
          Employee Diversity by Gender
        </Typography>
        <div className={classes.box}>
          <div
            className={classes.bar}
            style={{
              backgroundColor: "rgba(132, 107, 181, 0.8)",
            }}
          >
            <Typography className={classes.value}>
              {diversityValues?.employee_diversity_gender
                ?.employees_diversity_by_gender_male || 0}
              %
            </Typography>
          </div>
          <div
            className={classes.bar}
            style={{
              backgroundColor: "rgba(111, 191, 186, 0.8)",
            }}
          >
            <Typography className={classes.value}>
              {diversityValues?.employee_diversity_gender
                ?.employees_diversity_by_gender_female || 0}
              %
            </Typography>
          </div>
          <div
            className={classes.bar}
            style={{
              backgroundColor: "rgba(255, 199, 87, 0.8)",
            }}
          >
            <Typography className={classes.value}>
              {diversityValues?.employee_diversity_gender
                ?.employees_diversity_by_gender_other || 0}
              %
            </Typography>
          </div>
        </div>
        <div className={classes.caption}>
          <Typography variant="caption">% Male</Typography>
          <Typography variant="caption">% Female</Typography>
          <Typography variant="caption">% Non-Binary</Typography>
        </div>
        <Typography className={classes.subtitle}>
          Employee Diversity by Age-Group
        </Typography>
        <div className={classes.box}>
          <div
            className={classes.bar}
            style={{
              backgroundColor: "rgba(132, 107, 181, 0.8)",
            }}
          >
            <Typography className={classes.value}>
              {diversityValues?.employee_diversity_age
                ?.employees_diversity_by_age_under_30 || 0}
              %
            </Typography>
          </div>
          <div
            className={classes.bar}
            style={{
              backgroundColor: "rgba(111, 191, 186, 0.8)",
            }}
          >
            <Typography className={classes.value}>
              {diversityValues?.employee_diversity_age
                ?.employees_diversity_by_age_between_30_50 || 0}
              %
            </Typography>
          </div>
          <div
            className={classes.bar}
            style={{
              backgroundColor: "rgba(255, 199, 87, 0.8)",
            }}
          >
            <Typography className={classes.value}>
              {diversityValues?.employee_diversity_age
                ?.employees_diversity_by_age_over_50 || 0}
              %
            </Typography>
          </div>
        </div>
        <div className={classes.caption}>
          <Typography variant="caption">Under 30</Typography>
          <Typography variant="caption">Between 30-50</Typography>
          <Typography variant="caption">Above 50</Typography>
        </div>
      </div>
    </Paper>
  );
};

export default DiversityGraph;
